<div class="row mb-3">
    <div class="col-12">
        <span class="bms-exp-design" style="color: #B8D433; font-size: 20px;"></span>
        <span class="d-inline-flex p-2 h4 fw-bold" jhiTranslate="study-editor.experiment-design.title"></span>
        <jhi-help-link [helpKey]="HELP_MANAGE_STUDIES_EXPERIMENTAL_DESIGN"></jhi-help-link>
    </div>
</div>
<div class="row mb-3 experimental-design-details">
    <div class="col-6">
        @if (hasGeneratedDesign() && data.designType === ExperimentalDesignTypeEnum.CUSTOM_IMPORT.id) {
            <div class="row mb-3">
                <div class="col-12">
                    <span class="fs-6 fw-bold">{{ 'study-editor.experiment-design.details-of-experimental-design' | translate}}</span>
                </div>
            </div>
            <div class="row">
                <label for="customDesignFileName" class="col-sm-6 col-form-label fw-bold">{{ 'study-editor.experiment-design.imported-design-file-name' | translate }}
                </label>
                <div class="col-sm-6">
                   <span>{{studyDetails.experimentalDesignDetail?.experimentalDesignSource?.value}}</span>
                </div>
            </div>
            <div class="row">
                <label for="customDesign" class="col-sm-6 col-form-label fw-bold">{{ 'study-editor.experiment-design.design-type' | translate }}
                </label>
                <div class="col-sm-6">
                    <span>{{ 'study-editor.review-design.externally-generated-design' | translate }}</span>
                </div>
            </div>
        } @else {
            <div class="row mb-3">
                <div class="col-12 d-inline-flex align-items-center">
                    <label for="experimentalDesignType" class="col-4 fs-6 fw-bold" jhiTranslate="study-editor.experiment-design.choose-design-type.title"></label>
                    <div class="col-7 ms-3">
                        <ng-select name="experimentalDesignType" bindValue="id"
                                   [items]="designTypes" [(ngModel)]="data.designType" (change)="onChangeDesignType($event)"
                                   placeholder="{{'study-editor.experiment-design.select-design-type' | translate}}" [clearable]="true" [disabled]="hasGeneratedDesign()" required>
                            <ng-template ng-label-tmp let-item="item">
                                {{item.name | translate}}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                {{item.name | translate}}
                            </ng-template>
                        </ng-select>
					</div>
					<div class="col-1">
						<jhi-help-link helpTooltipKey="study-editor.experiment-design.incomplete.block.design.tooltip"></jhi-help-link>
                    </div>
                </div>
            </div>
            <div class="row mb-3" *ngIf="!hasGeneratedDesign() && principal.hasAnyAuthorityDirect(IMPORT_DESIGN_PERMISSIONS)">
				<div class="col-4"></div>
				<div class="col-8 d-inline-flex align-items-center ms-6">
                    {{ 'study-editor.experiment-design.import-design-description1' | translate}}
                    <button class="btn btn-sm btn-outline-info ms-2 me-2" (click)="importDesign()">{{ 'study-editor.experiment-design.import-design-import' | translate}}</button>
					{{ 'study-editor.experiment-design.import-design-description2' | translate}}
                </div>
            </div>
        }
        @if (data.designType !== null && data.designType !== undefined && data.designType !== ExperimentalDesignTypeEnum.CUSTOM_IMPORT.id) {
            <div class="row mb-3">
                <div class="col-12">
                    <span class="fs-6 fw-bold" jhiTranslate="study-editor.experiment-design.plot-numbering.title"></span>
                </div>
            </div>
            <div class="row mb-3">
                @if (principal.hasAnyAuthorityDirect(GENERATE_EXPERIMENTAL_DESIGN_PERMISSIONS) && !isImportedDesign()) {
                    @if (ExperimentalDesignTypeEnum.P_REP.id === data.designType) {
                        <label for="startingPlotNumber" class="col-sm-5 col-form-label" jhiTranslate="study-editor.experiment-design.plot-numbering.starting-plot">
                        </label>
                        <div class="col-sm-7">
                            <input type="number" class="form-control experimental-design-input" id="startingPlotNumber" [(ngModel)]="data.startingPlotNo" [disabled]="hasGeneratedDesign()" required>
                        </div>
                    } @else {
                        <label for="startingPlotNumber" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.plot-numbering.starting-plot">
                        </label>
                        <div class="col-sm-6">
                            <input type="number" class="form-control experimental-design-input" id="startingPlotNumber" [(ngModel)]="data.startingPlotNo" [disabled]="hasGeneratedDesign()" required>
                        </div>
                    }
                }
            </div>
        }
        @if (ExperimentalDesignTypeEnum.RANDOMIZED_COMPLETE_BLOCK.id === data.designType) {
            <div class="row mb-3">
                <span class="fs-6 fw-bold" jhiTranslate="study-editor.experiment-design.design-parameters.title"></span>
            </div>
            <ng-container [ngTemplateOutlet]="rcbd"></ng-container>
        }
        @if (ExperimentalDesignTypeEnum.RESOLVABLE_INCOMPLETE_BLOCK.id === data.designType) {
            <div class="row mb-3">
                <span class="fs-6 fw-bold" jhiTranslate="study-editor.experiment-design.design-parameters.title"></span>
            </div>
            <ng-container [ngTemplateOutlet]="ribd"></ng-container>
        }
        @if (ExperimentalDesignTypeEnum.ROW_COL.id === data.designType) {
            <div class="row mb-3">
                <span class="fs-6 fw-bold" jhiTranslate="study-editor.experiment-design.design-parameters.title"></span>
            </div>
            <ng-container [ngTemplateOutlet]="racd"></ng-container>
        }
        @if (ExperimentalDesignTypeEnum.P_REP.id === data.designType) {
            <div class="row mb-3">
                <span class="fs-6 fw-bold" jhiTranslate="study-editor.experiment-design.design-parameters.title"></span>
            </div>
            <ng-container [ngTemplateOutlet]="prep"></ng-container>
        }
        @if (ExperimentalDesignTypeEnum.AUGMENTED_RANDOMIZED_BLOCK.id === data.designType) {
            <div class="row mb-3">
                <span class="fs-6 fw-bold" jhiTranslate="study-editor.experiment-design.design-parameters.title"></span>
            </div>
            <ng-container [ngTemplateOutlet]="augmented"></ng-container>
        }
        @if (ExperimentalDesignTypeEnum.ENTRY_LIST_ORDER.id === data.designType && germplasmTotalCheckEntriesCount > 0) {
            <div class="row mb-3">
                <span class="fs-6 fw-bold" jhiTranslate="study-editor.experiment-design.design-parameters.title"></span>
            </div>
            <ng-container [ngTemplateOutlet]="eol"></ng-container>
        }
    </div>
    <div class="col-6">
        <ng-container [ngTemplateOutlet]="summaryDetails"></ng-container>
    </div>
</div>
<div class="row">
    <div class="col-12 d-flex justify-content-end">
        @if (principal.hasAnyAuthorityDirect(GENERATE_EXPERIMENTAL_DESIGN_PERMISSIONS) && data.designType !== ExperimentalDesignTypeEnum.CUSTOM_IMPORT.id) {
            <button class="btn btn-info" (click)="generateDesign()" jhiTranslate="study-editor.experiment-design.actions.generate"></button>
        }
        @if (principal.hasAnyAuthorityDirect(DELETE_EXPERIMENTAL_DESIGN_PERMISSIONS)) {
            <button class="btn btn-danger ms-2" (click)="deleteDesign()" [disabled]="isDeleteDesignDisable()">
                <i class="fa fa-trash"></i> <span class="ms-1" jhiTranslate="study-editor.experiment-design.actions.delete"></span>
            </button>
        }
    </div>
</div>
<div class="row" *ngIf="hasGeneratedDesign()">
	<jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study-editor.experiment-design.additional-details' | translate}}" [isCollapsed]="hideAdditionalDetailsPanel">
		<jhi-additional-design-details></jhi-additional-design-details>
	</jhi-collapsible>
</div>
<!--{{data | json}}-->

<ng-template #rcbd>
    <div class="row mb-3 align-items-center">
        <label for="numberOfReplications" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.replications">
        </label>
        <div class="col-sm-6">
            <div class="d-flex flex-column gap-2">
                <div style="min-width: 100px; flex-shrink: 0;">
                    <input type="number" class="form-control experimental-design-input" id="numberOfReplications" [(ngModel)]="data.replicationsCount" [disabled]="hasGeneratedDesign()" required>
                </div>
                <div class="flex-grow-1">
                    <div class="form-check form-switch d-flex align-items-center">
                        <input type="checkbox" class="form-check-input" name="firstRepNotRandomized" id="randFirstRep" [(ngModel)]="data.firstRepNotRandomized" (ngModelChange)="onFirstRepNotRandomizedChange()">
                        <label for="randFirstRep" class="form-check-label ms-2" jhiTranslate="study-editor.experiment-design.first.rep.not.randomized"></label>
                        @if (isNotRandFirstRepWarningShown) {
                            <i class="fa fa-exclamation-triangle fa-2x ms-2 text-warning" [ngbTooltip]="'study-editor.experiment-design.first.rep.not.randomized.warning' | translate"></i>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #ribd>
    <div class="row mb-3 align-items-center">
        <label for="numberOfReplications" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.replications">
        </label>
        <div class="col-sm-6">
            <div class="d-flex flex-column gap-2">
                <div style="min-width: 100px; flex-shrink: 0;">
                    <input type="number" class="form-control experimental-design-input" id="numberOfReplications" [(ngModel)]="data.replicationsCount" [disabled]="hasGeneratedDesign()" required>
                </div>
                <div class="flex-grow-1">
                    <div class="form-check form-switch d-flex align-items-center">
                        <input type="checkbox" class="form-check-input" name="firstRepNotRandomized" id="randFirstRep" [(ngModel)]="data.firstRepNotRandomized" (ngModelChange)="onFirstRepNotRandomizedChange()">
                        <label for="randFirstRep" class="form-check-label ms-2" jhiTranslate="study-editor.experiment-design.first.rep.not.randomized"></label>
                        @if (isNotRandFirstRepWarningShown) {
                            <i class="fa fa-exclamation-triangle fa-2x ms-2 text-warning" [ngbTooltip]="'study-editor.experiment-design.first.rep.not.randomized.warning' | translate"></i>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <label for="numberOfBlocks" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.block-size">
        </label>
        <div class="col-sm-6">
            <input type="number" class="form-control experimental-design-input" id="numberOfBlocks" [(ngModel)]="data.blockSize" [disabled]="hasGeneratedDesign()" required>
        </div>
    </div>
    <ng-container [ngTemplateOutlet]="advancedOptions"></ng-container>
</ng-template>
<ng-template #racd>
    <div class="row mb-3 align-items-center">
        <label for="numberOfReplications" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.replications">
        </label>
        <div class="col-sm-6">
            <div class="d-flex flex-column gap-2">
                <div style="min-width: 100px; flex-shrink: 0;">
                    <input type="number" class="form-control experimental-design-input" id="numberOfReplications" [(ngModel)]="data.replicationsCount" [disabled]="hasGeneratedDesign()" required>
                </div>
                <div class="flex-grow-1">
                    <div class="form-check form-switch d-flex align-items-center">
                        <input type="checkbox" class="form-check-input" name="firstRepNotRandomized" id="randFirstRep" [(ngModel)]="data.firstRepNotRandomized" (ngModelChange)="onFirstRepNotRandomizedChange()">
                        <label for="randFirstRep" class="form-check-label ms-2" jhiTranslate="study-editor.experiment-design.first.rep.not.randomized"></label>
                        @if (isNotRandFirstRepWarningShown) {
                            <i class="fa fa-exclamation-triangle fa-2x ms-2 text-warning" [ngbTooltip]="'study-editor.experiment-design.first.rep.not.randomized.warning' | translate"></i>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <label for="numberOfRowsInReplication" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.rows-in-replications">
        </label>
        <div class="col-sm-6">
            <input type="number" class="form-control experimental-design-input" id="numberOfRowsInReplication" [(ngModel)]="data.rowsPerReplications" [disabled]="hasGeneratedDesign()" required>
        </div>
    </div>
    <div class="row mb-3">
        <label for="numberOfColumnsInReplication" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.columns-in-replications">
        </label>
        <div class="col-sm-6">
            <input type="number" class="form-control experimental-design-input" id="numberOfColumnsInReplication" [(ngModel)]="data.colsPerReplications" [disabled]="hasGeneratedDesign()" required>
        </div>
    </div>
    <ng-container [ngTemplateOutlet]="advancedOptionsRowAndColumn"></ng-container>
</ng-template>
<ng-template #augmented>
    <div class="row mb-3">
        <label for="numberOfBlocks" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.number-of-blocks">
        </label>
        <div class="col-sm-6">
            <input type="number" class="form-control experimental-design-input" id="numberOfBlocks"
                   [(ngModel)]="data.numberOfBlocks"
                   (keyup)="augmentedParametersChangedSubject.next()"
                   (change)="augmentedParametersChangedSubject.next()"
                   [disabled]="hasGeneratedDesign()" required>
        </div>
    </div>
</ng-template>
<ng-template #prep>
    <div class="row mb-3">
        <label for="replicationPercentage" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.replication-percentage">
        </label>
        <div class="col-sm-6 d-inline-flex alignu-items-center">
            <input type="number" class="form-control experimental-design-input" id="replicationPercentage"
                   (keyup)="prepParametersChangedSubject.next()"
                   (change)="prepParametersChangedSubject.next()"
                   [(ngModel)]="data.replicationPercentage" [disabled]="hasGeneratedDesign()" required>
            <jhi-help-link helpTooltipKey="study-editor.experiment-design.prep-percentage-of-test-entries.tooltip"></jhi-help-link>
        </div>
    </div>
    <div class="row mb-3">
        <label for="numberOfReplications" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.replications">
        </label>
        <div class="col-sm-6 d-inline-flex align-items-center">
            <input type="number" class="form-control experimental-design-input" id="numberOfReplications"
                   (keyup)="prepParametersChangedSubject.next()"
                   (change)="prepParametersChangedSubject.next()"
                   [(ngModel)]="data.replicationsCount" [disabled]="hasGeneratedDesign()" required>
            <jhi-help-link helpTooltipKey="study-editor.experiment-design.no-of-replications.tooltip"></jhi-help-link>
        </div>
    </div>
    <div class="row mb-3">
        <label for="numberOfBlocks" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.block-size">
        </label>
        <div class="col-sm-6">
            <input type="number" class="form-control experimental-design-input" id="numberOfBlocks"
                   (keyup)="prepParametersChangedSubject.next()"
                   (change)="prepParametersChangedSubject.next()"
                   [(ngModel)]="data.blockSize" [disabled]="hasGeneratedDesign()" required>
        </div>
    </div>
</ng-template>
<ng-template #advancedOptions>
    <div class="row mb-3">
        <div class="col">
            <div class="form-check form-switch d-flex align-items-center">
                <input type="checkbox" class="form-check-input" name="showAdvancedOptions" id="showAdvancedOptions" [(ngModel)]="showAdvancedOptions" [disabled]="hasGeneratedDesign()">
                <label for="showAdvancedOptions" class="col-sm-4 col-form-label ms-1" jhiTranslate="study-editor.experiment-design.advanced-options.show"></label>
            </div>
        </div>
    </div>
    @if (showAdvancedOptions) {
        <div class="card card-body">
            <div class="row mb-3">
                <div class="col">
                    <div class="form-check form-check-inline d-flex align-items-center">
                        <input type="checkbox" class="form-check-input" name="useLatinizedDesign" id="useLatinizedDesign" [(ngModel)]="data.useLatenized" [disabled]="hasGeneratedDesign()">
                        <label for="useLatinizedDesign" class="col-sm-4 col-form-label ms-1" jhiTranslate="study-editor.experiment-design.advanced-options.use-latinized"></label>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.advanced-options.contiguous-blocks">
                </label>
                <div class="col-sm-6">
                    <input type="number" class="form-control experimental-design-input" [(ngModel)]="data.nblatin" [disabled]="hasGeneratedDesign() || !data.useLatenized" required>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.advanced-options.field-arrangement">
                </label>
                <div class="col-sm-6">
                    <ng-select class="experimental-design-select" [(ngModel)]="data.replicationsArrangement" [clearable]="false" [disabled]="hasGeneratedDesign() || !data.useLatenized" required>
                        <ng-option [value]="1" translate="study-editor.experiment-design.advanced-options.arrangement.single-column"></ng-option>
                        <ng-option [value]="2" translate="study-editor.experiment-design.advanced-options.arrangement.single-row"></ng-option>
                        <ng-option [value]="3" translate="study-editor.experiment-design.advanced-options.arrangement.adjacent-columns"></ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.advanced-options.reps-in-column">
                </label>
                <div class="col-sm-6 d-inline-flex align-items-center">
                    <input type="text" class="form-control experimental-design-input" [(ngModel)]="data.replatinGroups" [disabled]="hasGeneratedDesign() || !data.useLatenized || data.replicationsArrangement != 3" required>
                    <jhi-help-link helpTooltipKey="study-editor.experiment-design.latinized-number-of-reps-in-each-column.tooltip"></jhi-help-link>
                </div>
            </div>
        </div>
    }
</ng-template>
<ng-template #advancedOptionsRowAndColumn>
    <div class="row mb-3">
        <div class="col">
            <div class="form-check form-switch d-flex align-items-center">
                <input type="checkbox" class="form-check-input" name="showAdvancedOptions" id="showAdvancedOptions" [(ngModel)]="showAdvancedOptions" [disabled]="hasGeneratedDesign()">
                <label for="showAdvancedOptions" class="col-sm-4 col-form-label ms-1" jhiTranslate="study-editor.experiment-design.advanced-options.show"></label>
            </div>
        </div>
    </div>
    @if (showAdvancedOptions) {
        <div class="card card-body">
            <div class="row mb-3">
                <div class="col">
                    <div class="form-check form-check-inline d-flex align-items-center">
                        <input type="checkbox" class="form-check-input" name="useLatinizedDesign" id="useLatinizedDesign" [(ngModel)]="data.useLatenized" [disabled]="hasGeneratedDesign()">
                        <label for="useLatinizedDesign" class="col-sm-4 col-form-label ms-1" jhiTranslate="study-editor.experiment-design.advanced-options.use-latinized"></label>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.advanced-options.contiguous-rows">
                </label>
                <div class="col-sm-6">
                    <input type="number" class="form-control experimental-design-input" [(ngModel)]="data.nrlatin" [disabled]="hasGeneratedDesign() || !data.useLatenized" required>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.advanced-options.contiguous-columns">
                </label>
                <div class="col-sm-6">
                    <input type="number" class="form-control experimental-design-input" [(ngModel)]="data.nclatin" [disabled]="hasGeneratedDesign() || !data.useLatenized" required>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.advanced-options.field-arrangement">
                </label>
                <div class="col-sm-6">
                    <ng-select class="experimental-design-select" [(ngModel)]="data.replicationsArrangement" [clearable]="false" [disabled]="hasGeneratedDesign() || !data.useLatenized" required>
                        <ng-option [value]="1" translate="study-editor.experiment-design.advanced-options.arrangement.single-column"></ng-option>
                        <ng-option [value]="2" translate="study-editor.experiment-design.advanced-options.arrangement.single-row"></ng-option>
                        <ng-option [value]="3" translate="study-editor.experiment-design.advanced-options.arrangement.adjacent-columns"></ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.advanced-options.reps-in-column">
                </label>
                <div class="col-sm-6 d-inline-flex align-items-center">
                    <input type="text" class="form-control experimental-design-input" [(ngModel)]="data.replatinGroups" [disabled]="hasGeneratedDesign() || !data.useLatenized || data.replicationsArrangement != 3" required>
                    <jhi-help-link helpTooltipKey="study-editor.experiment-design.latinized-number-of-reps-in-each-column.tooltip"></jhi-help-link>
                </div>

            </div>
        </div>
    }
</ng-template>
<ng-template #eol>
    <div class="row mb-3">
        <label for="checkStartingPosition" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.starting-position">
        </label>
        <div class="col-sm-6">
            <input type="number" class="form-control experimental-design-input" id="checkStartingPosition" [(ngModel)]="data.checkStartingPosition" [disabled]="hasGeneratedDesign()" required>
        </div>
    </div>
    <div class="row mb-3">
        <label for="checkSpacing" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.spacing">
        </label>
        <div class="col-sm-6">
            <input type="number" class="form-control experimental-design-input" id="checkSpacing" [(ngModel)]="data.checkSpacing" [disabled]="hasGeneratedDesign()" required>
        </div>
    </div>
    <div class="row mb-3">
        <label for="checkInsertionManner" class="col-sm-6 col-form-label" jhiTranslate="study-editor.experiment-design.design-parameters.insertion-manner">
        </label>
        <div class="col-sm-6">
            <ng-select class="experimental-design-select" bindValue="id" bindLabel="description" [items]="insertionManners" [(ngModel)]="data.checkInsertionManner" [clearable]="false" [disabled]="hasGeneratedDesign()" required>
            </ng-select>
        </div>
    </div>
</ng-template>

<ng-template #summaryDetails>
    @if (isBVDesign()) {
        <div class="card bg-white">
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col">
                        <span class="fs-6 fw-bold" jhiTranslate="study-editor.experiment-design.summary.title"></span>
                    </div>
                </div>
                <div class="row mb-2" *ngIf="noOfEnvironments >= 0">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.environments"></span>
                    </div>
                    <div class="col">
                        <span class="value-chip">{{noOfEnvironments || '-'}}</span>
                    </div>
                </div>

                <div class="row mb-2" *ngIf="currentDesignType.id != 5">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.treatments">Number of treatments:</span>
                    </div>
                    <div class="col">
                        <span class="value-chip">{{totalGermplasmEntryListCount || '-'}}</span>
                    </div>
                </div>
                <div class="row mb-2" *ngIf="currentDesignType.id == 1">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.blocks-per-replication">Number of blocks per replication:</span>
                    </div>
                    <div class="col">
                        <span class="value-chip">{{(data.blockSize
                            > 0) ? ((totalGermplasmEntryListCount % data.blockSize === 0) ?
                            totalGermplasmEntryListCount / data.blockSize : '') : 0}} <b
                                class="text-danger"
                                *ngIf="data.blockSize > 0 && totalGermplasmEntryListCount % data.blockSize > 0">Invalid block size</b></span>
                    </div>
                </div>
                <div class="row mb-2" *ngIf="currentDesignType.id == 4 || currentDesignType.id == 6">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.test-entries">Number of Test entries:</span>
                    </div>
                    <div class="col">
                        <span class="value-chip">{{germplasmTotalTestEntriesCount || '-'}}</span>
                    </div>
                </div>
                <div class="row mb-2" *ngIf="currentDesignType.id == 4 || currentDesignType.id == 6">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.check-entries">Number of Check entries:</span>
                    </div>
                    <div class="col">
                        <span class="value-chip">{{germplasmTotalCheckEntriesCount || '-'}}</span>
                    </div>
                </div>
                <div class="row mb-2" *ngIf="currentDesignType.id == 6">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.non-replicated-entries">Number of Non Replicated entries:</span>
                    </div>
                    <div class="col">
                        <span class="value-chip">{{germplasmTotalNonReplicatedEntriesCounts || '-'}}</span>
                    </div>
                </div>
                <div class="row mb-2" *ngIf="showOnlyIfNumberOfBlocksIsSpecified()">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.test-entries-per-block">Number of Test entries per block:</span>
                    </div>
                    <div class="col">
                        <span class="value-chip" *ngIf="germplasmNumberOfTestEntriesPerBlock % 1 === 0">{{germplasmNumberOfTestEntriesPerBlock || '-'}}</span>
                        <span class="value-chip" *ngIf="germplasmNumberOfTestEntriesPerBlock % 1 !== 0">
							<b class="text-danger"><span jhiTranslate="study-editor.experiment-design.summary.entries-blocks-error">The number of test entries must be divisible by number of blocks.</span></b>
                        </span>
                    </div>
                </div>
                <div class="row mb-2" *ngIf="showOnlyIfNumberOfBlocksIsSpecified()">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.plots-per-block">Number of plots per block:</span>
                    </div>
                    <div class="col">
                        <span class="value-chip" *ngIf="germplasmNumberOfTestEntriesPerBlock % 1 === 0">{{germplasmNumberOfPlotsPerBlock || '-'}}</span>
                    </div>
                </div>
                <div class="row mb-2" *ngIf="showOnlyIfNumberOfBlocksIsSpecified()">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.total-plots">Total number of plots:</span>
                    </div>
                    <div class="col">
                        <span class="value-chip" *ngIf="germplasmNumberOfTestEntriesPerBlock % 1 === 0">{{germplasmTotalNumberOfPlots || '-'}}</span>
                    </div>

                </div>
                <div class="row mb-2" *ngIf="showOnlyIfNumberOfBlockSizeIsSpecified()">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.entries-per-block">Number of entries per block:</span>
                    </div>
                    <div class="col">
                        <span class="value-chip" *ngIf="germplasmNumberOfPlotsPerBlock % 1 === 0">{{germplasmNumberOfPlotsPerBlock || '-'}}</span>
                        <span class="value-chip" *ngIf="germplasmNumberOfPlotsPerBlock % 1 !== 0">
                        <b class="text-danger"><span jhiTranslate="study-editor.experiment-design.summary.plots-blocks-error">The Total number of plots must be divisible by number of blocks.</span></b>
                    </span>
                    </div>
                </div>
                <div class="row mb-2" *ngIf="showOnlyIfNumberOfReplicationsCountIsSpecified()">
                    <div class="col">
                        <span jhiTranslate="study-editor.experiment-design.summary.total-plots">Total number of plots:</span>
                    </div>
                    <div class="col">
                        <span class="value-chip">{{germplasmTotalNumberOfPlots || '-'}}</span>
                    </div>
                </div>
                <div class="row mb-2" *ngFor="let item of getSpecialFactorsByDesignType()">
                    <div class="col">
                        <span>{{ item.label | translate }}</span>
                    </div>
                    <div class="col">
                        <span class="value-chip">
                              <a [routerLink]=" ['/', { outlets: { popup: 'variable-details-popup' }}]"
                                 [queryParams]="{ variableId: item.termId }"
                                 queryParamsHandling="merge">{{item.name || '-'}}</a>
                        </span>
                    </div>
                </div>
                @if (currentDesignType.id == 0) {
                    <div class="row mb-3">
                        <div class="col">
                            <span class="fw-bold" jhiTranslate="study-editor.experiment-design.summary.treatment-factors">Treatment factors:</span>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col">
                            <table class="table table-striped table-curved">
                                <thead>
                                <tr>
									<th><span jhiTranslate="study-editor.experiment-design.summary.table.name">NAME</span></th>
									<th><span jhiTranslate="study-editor.experiment-design.summary.table.description">DESCRIPTION</span></th>
									<th><span jhiTranslate="study-editor.experiment-design.summary.table.levels"># LEVELS</span></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td class="even"><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                        [queryParams]="{ variableId: entryDetailSettingsMap.get(8230).termId }"
                                                        queryParamsHandling="merge">{{entryDetailSettingsMap.get(8230).name}}</a>
                                    </td>
                                    <td class="even">{{entryDetailSettingsMap.get(8230).description}}</td>
                                    <td class="even">{{totalGermplasmEntryListCount}}</td>
                                </tr>

                                <tr *ngFor="let treatmentKey of Array.from(studyDetails.treatmentFactors.keys())">
                                    <td><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                           [queryParams]="{ variableId: treatmentKey }"
                                           queryParamsHandling="merge">{{studyDetails.treatmentFactors[treatmentKey].levelVariable.name}}</a>
                                    </td>
                                    <td>{{studyDetails.treatmentFactors[treatmentKey].levelVariable.description}}</td>
                                    <td>{{studyDetails.treatmentFactors[treatmentKey].values.length}}</td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</ng-template>
